import { useEffect, useState } from "react";

const fmt = (n) => Math.round(n).toLocaleString();

/** Live Kenya population, ticking from the Worldometer estimate, with the 2019 census formula. */
export const LivePopulation = ({ pop, compact = false }) => {
  const [value, setValue] = useState(pop?.live_population || 0);

  useEffect(() => {
    if (!pop?.live_population) return undefined;
    const base = pop.live_population;
    const start = new Date(pop.as_of).getTime();
    const perSecond = (base * (pop.growth_rate_pct / 100)) / (365 * 24 * 3600);
    const tick = () => setValue(base + ((Date.now() - start) / 1000) * perSecond);
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [pop]);

  if (!pop?.live_population) return null;

  if (compact)
    return (
      <span className="mono" data-testid="live-population-compact">
        <span className="text-ochre">{fmt(value)}</span> Kenyans now (Worldometer) · 2019 census base{" "}
        {fmt(pop.census_population)}
      </span>
    );

  return (
    <div className="border border-white/10 bg-[#0b0b0b] p-6 md:p-8" data-testid="live-population">
      <p className="overline text-ochre">Kenya population, live</p>
      <p
        className="mono mt-4 text-3xl font-bold leading-none text-white md:text-5xl"
        data-testid="live-population-value"
      >
        {fmt(value)}
      </p>
      <div className="mono mt-6 grid gap-3 text-xs text-zinc-400 sm:grid-cols-3">
        <span data-testid="live-population-census">
          2019 census base <span className="text-white">{fmt(pop.census_population)}</span>
        </span>
        <span data-testid="live-population-growth">
          Growth since census <span className="text-white">+{fmt(pop.growth_since_census)}</span>
        </span>
        <span data-testid="live-population-factor">
          Scale factor <span className="text-white">x{pop.scale_factor}</span>
        </span>
      </div>
      <p className="mt-6 max-w-3xl text-sm leading-relaxed text-zinc-400" data-testid="live-population-formula">
        {pop.formula}
      </p>
      <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-zinc-300">
        {(pop.sources || []).map((s) => (
          <a
            key={s.url}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-4 hover:text-ochre"
            data-testid={`live-population-source-${s.url.includes("worldometers") ? "worldometer" : "census"}`}
          >
            {s.source}
          </a>
        ))}
        <span>Updated {new Date(pop.as_of).toUTCString()}</span>
      </div>
    </div>
  );
};
